import {
  FETCH_PROFILE_SUCCESS,
  SHOW_PROFILE_MESSAGE,
  UPDATE_PROFILE_SUCCESS,
  SHOW_PROFILE_BUTTON_LOADER,
  SHOW_PASSWORD_BUTTON_LOADER,
  SHOW_PROFILE_PASSWORD_BUTTON_LOADER,
  UPDATE_PROFILE_PASSWORD_SUCCESS,
  HIDE_PROFILE_MESSAGE
} from 'constants/ActionTypes';

const INIT_STATE = {
  loader: true,
  alertMessage: '',
  showMessage: false,
  btnUpdateProfile: false,
  btnPassword: false,
  isErrorMessage: false,
  user: {}
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_PROFILE_SUCCESS: {
      return {
        ...state,
        loader: false,
        user: action.payload,
      }
    }
    case SHOW_PROFILE_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload.message,
        isErrorMessage: action.payload.messageStatus,
        showMessage: true,
        btnUpdateProfile: false,
        btnPassword: false,
        loader: false
      }
    }
    case UPDATE_PROFILE_SUCCESS: {
      return {
        ...state,
        alertMessage: action.payload.message,
        isErrorMessage: action.payload.messageStatus,
        showMessage: true,
        btnUpdateProfile: false,
        loader: false
      }
    }
    case SHOW_PROFILE_BUTTON_LOADER: {
      return {
        ...state,
        btnUpdateProfile: true
      }
    }
    case SHOW_PASSWORD_BUTTON_LOADER: {
      return {
        ...state,
        btnPassword: true
      }
    }
    case SHOW_PROFILE_PASSWORD_BUTTON_LOADER: {
      return {
        ...state,
        btnPassword: true
      }
    }
    case UPDATE_PROFILE_PASSWORD_SUCCESS: {
      return {
        ...state,
        alertMessage: 'user.passwordSuccessChange',
        isErrorMessage: false,
        showMessage: true,
        btnUpdateProfile: false,
        btnPassword: false,
      }
    }
    case HIDE_PROFILE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        isErrorMessage: false,
        showMessage: false,
        loader: false
      }
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/Profile.js